export const nextTick = (cb) => {
	return new Promise(resolve => {
		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				cb()
				resolve()
			})
		})
	})
}